import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import { THEME_SETTING } from "../../pages/trivia/data";
import "./rangeInput.css";
export default function RangeInput({
  min,
  max,
  value,
  onChange = () => {},
  className,
  themeSettings = THEME_SETTING,
  options = [],
  minLabel = "Lowest",
  maxLabel = "Highest",
  editableLabels = false,
  onMinLabelChange = () => {},
  onMaxLabelChange = () => {},
  isAdmin
}) {
  const [array, setArray] = useState([...Array(max).keys()].map((i) => i + 1));
  const [selectedValue, setSelectedValue] = useState(value);
  useEffect(()=>{
    setSelectedValue(value); // Update selected value when value changes
  },[value])

  useEffect(() => {
    if (max) {
      let arr = [
        ...Array(typeof max == "string" ? parseInt(max) : max).keys(),
      ].map((i) => i + 1);
      arr = arr.filter((x) => x >= min);
      setArray(arr);
    }
  }, [max, min]);

  const handleRadioChange = (val) => {
    setSelectedValue(val); // Update selected value
    onChange(val); // Notify parent component of the change
  };

  const renderLabelInput = (value, placeholder, onChange, labelType) => (
    <input
      type="text"
      defaultValue={value}
      onBlur={(e) => onChange(e.target.value)}
      style={{
        border: 'none',
        borderBottom: `1px solid #ccc`,
        padding: '2px 4px',
        fontSize: '16px',
        background: 'transparent',
        color: 'inherit',
        outline: 'none'
      }}
      placeholder={placeholder}
      onClick={(e) => e.stopPropagation()}
    />
  );

  return (
    <div className={`rangeInput_wrapper ${className}`}>
      {array.map((x, index) => {
        const isSelected = value >= x;
        return (
          <div key={index} className={`rangeInput_radio_wrapper`}>
            <input
              type="radio"
              id={`radio-${x}`}
              name="rangeInputRadio" // Ensure all radios share the same name
              value={x}
              checked={selectedValue === x} // Mark as selected if matches
              onChange={() => handleRadioChange(x)}
            />
            <label htmlFor={`radio-${x}`}>
              {options[x - 1] ? options[x - 1].text : x}{" "}
              {/* Show options or the value */}
              {index == 0 ? (
                editableLabels && isAdmin ? renderLabelInput(minLabel, "Lowest", onMinLabelChange, "min") : minLabel
              ) : index === array.length - 1 ? (
                editableLabels && isAdmin ? renderLabelInput(maxLabel, "Highest", onMaxLabelChange, "max") : maxLabel
              ) : ""}
            </label>
          </div>

          // <div
          // key={index}
          //   className={`rangeInput_number_box`}
          //   onClick={() => onChange(x)}
          //   style={{
          //     background:isSelected?themeSettings.quizTextColor:"white",
          //     color:isSelected?"white":themeSettings.quizTextColor
          //   }}
          //   data-tip={options[x-1] && options[x-1].text || ""}
          // >

          //   {x}
          // </div>
        );
      })}
    </div>
  );
}
